module.exports = __webpack_public_path__ + "img/金钥匙优胜奖-北京全景.65aecf31.png";